module.exports = __webpack_public_path__ + "static/media/vdcalseyde2_cropped.724bb16a.png";